// extracted by mini-css-extract-plugin
export default {"stockroomBody":"YfdlbVmAq51iNhmhFUuV","stockroomIcon":"i1IbSf3Ueu4resSQFMc5","stockroomTabIcon":"cqNVmb5OGohpyPoXuHVZ"};